const LoaderBox = {
  position: "fixed",
  right: "15px",
  bottom: "0",
  zIndex: 9999,
};
const ErrorBox = {
  position: "fixed",
  right: "30px",
  bottom: "20px",
  zIndex: 9999,
};

export default {
  LoaderBox,
  ErrorBox,
};
